<integrations-connect-to-service [service]="microsoft" [connectionInfoKey]="serviceKey" [useAlternateStyling]="true">
  <integrations-connect-element>
    <ng-container [ngTemplateOutlet]="microsoftButton" [ngTemplateOutletContext]="{ label: signInKey | translate, isMeetingApp: isMeetingApp }"></ng-container>
  </integrations-connect-element>
  @if (primaryDisconnect) {
    <integrations-disconnect-element>
      <ng-container
        [ngTemplateOutlet]="microsoftButton"
        [ngTemplateOutletContext]="{ label: disconnectKey | translate, isMeetingApp: isMeetingApp }"
      ></ng-container>
    </integrations-disconnect-element>
  }
</integrations-connect-to-service>

@if (!primaryDisconnect && isConnected$ | async) {
  <ng-container
    [ngTemplateOutlet]="microsoftButtonSecondaryDisconnect"
  ></ng-container>
}

<ng-template #microsoftButtonSecondaryDisconnect>
  <integrations-connect-to-service [service]="microsoft" [connectionInfoKey]="serviceKey" [useAlternateStyling]="true">
    <integrations-disconnect-element>
      <ng-container [ngTemplateOutlet]="microsoftDisconnectButton"></ng-container>
    </integrations-disconnect-element>
  </integrations-connect-to-service>
</ng-template>

<ng-template #microsoftButton let-label="label" let-cursor="cursor" let-isMeetingApp="isMeetingApp">
  <button
    class="microsoft-button-container"
    matStepperNext
    [disabled]="!primaryDisconnect && (isConnected$ | async)"
    [ngStyle]="{ cursor: cursor || 'pointer' }"
    >
    @if (isMeetingApp !== true) {
      <div class="microsoft-icon-container">
        <img
          class="microsoft-icon"
          src="https://storage.googleapis.com/meeting-scheduler-prod-public-images/microsoft-logo.svg"
          />
      </div>
    }
    <div class="sign-in-text" [class.no-icon]="isMeetingApp === true">
      <span>{{ label }}</span>
    </div>
  </button>
</ng-template>
<ng-template #microsoftDisconnectButton>
  <button mat-stroked-button class="secondary-disconnect" matStepperNext (click)="openDisconnectDialog($event)">
    <div class="microsoft-icon-container">
      <img
        class="microsoft-icon"
        src="https://storage.googleapis.com/meeting-scheduler-prod-public-images/microsoft-logo.svg"
        />
    </div>
    <div class="disconnect-text">
      <span>{{ disconnectSecondaryKey | translate }}</span>
    </div>
  </button>
</ng-template>
